// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-63335cef]{display:none}.suggestions-entry[data-v-63335cef]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin:0}.suggestions-entry .query-text[data-v-63335cef]{font-weight:500}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
